<template>
<div class="chapter">
<div class="inner_page">
<p class="Prai-title"><span>PRAISE FOR THE WRITING OF KATHERINE NEVILLE</span></p>
<p class="Prai-section1"><span><i>The Eight</i></span></p>
<p class="Prai-normal">“With alchemical skill, Neville blends modern romance, historical fiction, and medieval mystery … and comes up with gold.” —<i>People</i></p>
<p class="Prai-normal">“A fascinating piece of entertainment that manages to be both vibrant and cerebral. … Few will find it resistible.” —<i>Los Angeles Times Book Review</i></p>
<p class="Prai-normal">“Daring, original, and moving, [<i>The Eight</i>] seems destined to become a cult classic.” —<i>Publishers Weekly</i></p>
<p class="Prai-normal">“Readers thrilled by <i>The Da Vinci Code</i> will relish the multilayered secrets of <i>The Eight</i>.” —Matthew Pearl, author of <i>The Dante Club</i></p>
<p class="Prai-normal">“A feminist answer to <i>Raiders of the Lost Ark</i>.” —<i>The Washington Post Book World</i></p>
<p class="Prai-normal">“The female counterpart to Umberto Eco’s <i>The Name of the Rose</i> … impossible to put down.” —<i>Boston Herald</i></p>
<p class="Prai-section1"><span><i>A Calculated Risk</i></span></p>
<p class="Prai-section2"><span>A New York Times Notable Book</span></p>
<p class="Prai-normal">“Never a dull moment, and [Neville] makes it all the more plausible because of her intimate knowledge of how international banking works. … [Her] book churns up wave after wave of excitement.” —<i>The New York Times Book Review</i></p>
<p class="Prai-normal">“Great fun … [A] lean, taut thriller.” —<i>San Jose Mercury News</i></p>
<p class="Prai-section1"><span><i>The Magic Circle</i></span></p>
<p class="Prai-normal">“Filled with intrigue … Neville keeps the novel moving at a fast pace.” —<i>The Denver Post</i></p>
<p class="Prai-normal">“[A] racing-across-the-globe, one-step-ahead-of-the-bad-guys treasure hunt.” —<i>Detroit Free Press</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter02.vue?6ff23216